import * as React from "react";
export interface AppContextInterface {
  userProfileCount?: number;
  userId: number;
  userName: string;
  displayName: string;
  name: string;
  userIsStaff: boolean;
  profileCount: number;
  isFullScreenView: boolean;
  role: "staff" | "customer" | "payee";
  email: string;
  viewingAs: boolean;
  setUserProfile: (data: any) => void;
  isStaging: boolean;
  userProfile?: {
    id: number | string;
  };
}

export default React.createContext<AppContextInterface>(
  {} as AppContextInterface,
);
